import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";
import "../../css/Employee.css";

const DistributorList = () => {
  const [distributorData, setDistributorData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage, setEmployeesPerPage] = useState(10);
  const [showListFilter, setShowListFilter] = useState(false);
  const [zoomImageUrl, setZoomImageUrl] = useState(null);

  const listFilterRef = useRef(null);

  useEffect(() => {
  api
    .get("/get/distributor/list")
    .then((response) => {
      if (response.data.success) {
        const sortedData = [...response.data.data].reverse(); // Newest entries first
        setDistributorData(sortedData);
        setFilteredData(sortedData);
      }
    })
    .catch((error) => {
      console.error("Error fetching distributors:", error);
    })
    .finally(() => {
      setLoading(false);
    });
}, []);

  useEffect(() => {
    let dataToFilter = distributorData;

    if (searchTerm.trim() !== "") {
      const search = searchTerm.toLowerCase();
      dataToFilter = distributorData.filter((dist) => {
        return (
          (dist.name || "").toLowerCase().includes(search) ||
          (dist.code || "").toString().toLowerCase().includes(search) ||
          (dist.email || "").toLowerCase().includes(search) ||
          (dist.country || "").toLowerCase().includes(search) ||
          (dist.state || "").toLowerCase().includes(search) ||
          (dist.district || "").toLowerCase().includes(search) ||
          (dist.tehsil || "").toLowerCase().includes(search) ||
          (dist.village || "").toLowerCase().includes(search) ||
          (dist.city || "").toLowerCase().includes(search) ||
          (dist.phone || "").toLowerCase().includes(search) ||
          (dist.tax_number || "").toLowerCase().includes(search) ||
          (dist.adresse || "").toLowerCase().includes(search) ||
          (dist.document || "").toLowerCase().includes(search) ||
          (dist.document_number || "").toLowerCase().includes(search) ||
          (dist.status || "").toLowerCase().includes(search) ||
          (dist.documents || []).some(
            (doc) =>
              (doc.document_type || "").toLowerCase().includes(search) ||
              (doc.document_number || "").toLowerCase().includes(search)
          )
        );
      });
    }

    setFilteredData(dataToFilter);
    setCurrentPage(1);
  }, [searchTerm, distributorData]);

  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = filteredData.slice(
    indexOfFirstEmployee,
    indexOfLastEmployee
  );
  const totalPages = Math.ceil(filteredData.length / employeesPerPage);

  const handlePerPageChange = (value) => {
    setEmployeesPerPage(value);
    setShowListFilter(false);
    setCurrentPage(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        listFilterRef.current &&
        !listFilterRef.current.contains(event.target)
      ) {
        setShowListFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeZoomModal = () => {
    setZoomImageUrl(null);
  };

  return (
    <section className="employee-section">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Distributor Details</h2>
          <div className="right-filter">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="list-fliter tooltip-wrapper" ref={listFilterRef} data-tooltip="Filter by List">
              <button onClick={() => setShowListFilter(!showListFilter)}>
                <i className="fa-solid fa-filter"></i>
              </button>
              {showListFilter && (
                <div className="filter-data">
                  {[10, 30, 50, 100].map((number) => (
                    <div
                      key={number}
                      className={`filter-option ${
                        employeesPerPage === number ? "selected" : ""
                      }`}
                      onClick={() => handlePerPageChange(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="employee-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Firm Name</th>
                    <th>Code</th>
                    <th>Email</th>
                    <th>Country</th>
                    <th>State</th>
                    <th>District</th>
                    <th>Tehsil</th>
                    <th>Village</th>
                    
                    <th>Phone</th>
                    <th>GST Number</th>
                    <th>Address</th>

                    <th>Documents</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentEmployees.map((dist, index) => (
                    <tr key={index}>
                      <td>{indexOfFirstEmployee + index + 1}</td>
                      <td>{dist.name}</td>
                      <td>{dist.firm_name}</td>
                      <td className="check-in">{dist.code}</td>
                      <td>{dist.email}</td>
                      <td>{dist.country}</td>
                      <td className="state">{dist.state}</td>
                      <td className="p-day">{dist.district}</td>
                      <td className="check-in">{dist.tehsil}</td>
                      <td>{dist.village}</td>
                      <td className="phone">
                        <i class="fa-solid fa-phone"></i>&nbsp; {dist.phone}
                      </td>
                      <td className="check-in">{dist.tax_number}</td>
                      <td className="address">{dist.state}, {dist.district}, {dist.tehsil}, {dist.village}</td>

                      <td>
                        {dist.documents && dist.documents.length > 0
                          ? dist.documents.map((doc, docIndex) => (
                              <div
                                key={docIndex}
                                style={{ marginBottom: "8px" }}
                              >
                                <strong>
                                  {doc.document_type?.toUpperCase()}
                                </strong>
                                <br />
                                <small>#{doc.document_number}</small>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "8px",
                                    flexWrap: "wrap",
                                    marginTop: "6px",
                                    justifyContent: "center",
                                  }}
                                >
                                  {[
                                    doc.document_image1,
                                    doc.document_image2,
                                    doc.document_image3,
                                  ]
                                    .filter(Boolean)
                                    .map((img, imgIndex) => (
                                      <i
                                        key={`${docIndex}-${imgIndex}`}
                                        className="fa-solid fa-images"
                                        style={{
                                          fontSize: "35px",
                                          color: "#5b8c51",
                                          cursor: "pointer",
                                        }}
                                        title={`View Document ${imgIndex + 1}`}
                                        onClick={() => setZoomImageUrl(img)}
                                      ></i>
                                    ))}
                                </div>
                              </div>
                            ))
                          : ""}
                      </td>

                      <td
                        style={{
                          color:
                            dist.status === "active"
                              ? "#28a745"
                              : dist.status === "pending"
                              ? "#f64b34"
                              : undefined,
                          fontWeight: "bold",
                        }}
                      >
                        <span className="status">{dist.status || "-"}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}

        {zoomImageUrl && (
          <div className="zoom-modal-overlay" onClick={closeZoomModal}>
            <div
              className="zoom-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-btn" onClick={closeZoomModal}>
                <i className="fa-solid fa-xmark"></i>
              </button>
              <img
                src={zoomImageUrl}
                alt="Zoomed Document"
                className="zoomed-image"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DistributorList;
